module.exports = __webpack_public_path__ + "img/udm.e70ac69e.svg";